import type { OcupacaoDoMes } from "@bookdental/schemas";

/** Linha por sala como chega de `salas.ocupacao` (a regra mais o nome e a cor). */
export type SalaDaOcupacao = OcupacaoDoMes["salas"][number] & { nome: string; cor: string | null };
export type Ocupacao = Omit<OcupacaoDoMes, "salas"> & { salas: SalaDaOcupacao[] };

/** Fração de 0 a 1, ou nula quando não há base (mês sem expediente, uso real sem dia passado). */
export const fracao = (parte: number, base: number) => (base > 0 ? parte / base : null);
export const pct = (f: number | null) => (f === null ? "—" : `${Math.round(f * 100)}%`);
/** 135 → "2h15"; 45 → "45 min". */
export const horas = (min: number) => {
  if (min < 60) return `${Math.round(min)} min`;
  const h = Math.floor(min / 60);
  const m = Math.round(min % 60);
  return m ? `${h}h${String(m).padStart(2, "0")}` : `${h}h`;
};
const media = (xs: number[]) => (xs.length ? Math.round(xs.reduce((a, b) => a + b, 0) / xs.length) : null);
export const atrasoMedio = (s: SalaDaOcupacao) => media(s.atrasos);
export const estouroMedio = (s: SalaDaOcupacao) => media(s.estouros);
